var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-gray-lighten3 pb-20 md:pb-28",attrs:{"id":_vm.data.id}},[_c(_setup.isDesktop ? _setup.CategoryFeaturesBlocks : _setup.CategoryFeaturesBlocksMobile,{tag:"component",attrs:{"items":_setup.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }